'use client';

import { getTeamQuota } from '@/app/apis';
import { useFetch } from '@/app/hooks';
import { useStore } from '@/app/providers/store';
import type { UserQuotaInfo } from '@/app/stores/slices/user-info';
import { tasksGetUserQuota } from '../apis';

/**
 * 在 create 下仅挂载一次，统一拉取错峰余量并写入 store，避免多个 Settings 重复请求。
 * - 旗舰版：通过 tasksGetUserQuota 获取个人错峰余量
 * - 企业版：通过 getTeamQuota 获取团队错峰余量
 * 提交任务后 invalidateUserQuota 递增会触发重拉。
 */
export const UserQuotaSync = () => {
  const { isUnlimited, isTeamSpace } = useStore((state) => {
    return {
      isUnlimited: state.userInfo?.subs_plan === 'ultimate_v2',
      isTeamSpace: state.isTeamSpace,
    };
  });
  const userQuotaRefreshVersion = useStore((state) => state.userQuotaRefreshVersion);
  const updateUserQuota = useStore((state) => state.updateUserQuota);

  useFetch(() => tasksGetUserQuota({}), {
    ready: !isTeamSpace && isUnlimited,
    refreshDeps: [userQuotaRefreshVersion],
    onSuccess: (result) => {
      if (result?.data != null) {
        updateUserQuota(result.data as UserQuotaInfo);
      }
    },
  });

  useFetch(getTeamQuota, {
    ready: isTeamSpace,
    refreshDeps: [userQuotaRefreshVersion],
    onSuccess: (result) => {
      const nopeak_quota = result?.data?.quota?.nopeak_quota;
      if (nopeak_quota != null) {
        updateUserQuota({ nopeak_quota });
      }
    },
  });

  return null;
};
